import { default as ZipPlusMMPDialog } from './ZipPlusMMPDialog';

export default ZipPlusMMPDialog;
